export default "/images/ico-h-calendar.svg?f6fac44696a110cb33d02562d5660712";